import { useTranslation } from 'react-i18next';
import { ROUTE } from 'src/constants';

export const usePathnameTitle = () => {
  const { t } = useTranslation('pathname_title');

  const TITLE_BY_PATHNAME = {
    [ROUTE.AUTH.DESKTOP_OAUTH_AUTHORIZE]: t('dashboard'),
    [ROUTE.DASHBOARD.MAIN]: t('dashboard'),
    [ROUTE.DASHBOARD.RULES]: t('rules'),
    [ROUTE.DASHBOARD.COMMANDS]: t('commands'),
    [ROUTE.DASHBOARD.AUTOMODE]: t('automode'),
    [ROUTE.DASHBOARD.CHAOS]: t('chaos'),
    [ROUTE.DASHBOARD.CHAOS_WIDGET]: t('chaos_widget'),
    [ROUTE.DASHBOARD.GIVEAWAY]: t('giveaway'),
    [ROUTE.DASHBOARD.GIVEAWAY_EMBED]: t('giveaway_embed'),
    [ROUTE.DASHBOARD.VIEWERS]: t('viewers'),
    [ROUTE.DASHBOARD.PROFILE]: t('profile'),
    [ROUTE.DASHBOARD.USERS]: t('users')
  };

  return { TITLE_BY_PATHNAME };
};
